import React, { useEffect, useState } from "react";
import "./SalesReport.scss";
import { CircularProgress, IconButton } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import Header from "../../Home/Header/Header";
import CustomTextField from "../../../TextFiled/Index";

const SalesReport = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("Report_Sale")
      .then((response) => {
        if (response?.Data?.DT) {
          const formatted = response.Data.DT.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          setSaleData(formatted);
          setFilteredData(formatted);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchQuery(value);
    const filtered = saleData.filter((item) =>
      item.CustomerCode.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredData(saleData);
  };

  return (
    <div className="sales_main">
      <Header otherPage={true} title="Sales Report" />
      <div className="sales_container">
        <div className="search_input_wrapper">
          <CustomTextField
            className="searchBox_input"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search Customer Code"
            InputProps={{
              endAdornment: searchQuery && (
                <IconButton onClick={clearSearch}>
                  <IoMdClose className="search_clear_icon" />
                </IconButton>
              ),
            }}
          />
        </div>

        {isLoading ? (
          <div className="loading_wrapper">
            <CircularProgress />
          </div>
        ) : filteredData.length === 0 ? (
          <div className="nodata">No Data Found</div>
        ) : (
          <div className="sales_scroll_list">
            {filteredData.map((item) => (
              <div className="sales_card" key={item.id}>
                <div className="card_top">
                  <div className="code_label"></div>
                  <div className="code_value">{item.CustomerCode}</div>
                </div>
                <div className="card_body">
                  <div className="row_item">
                    <span className="label">Bills</span>
                    <span className="value">{item.TotalBill}</span>
                  </div>
                  <div className="row_item">
                    <span className="label">Amount</span>
                    <span className="value">₹ {item.TotalAmount.toFixed(2)}</span>
                  </div>
                  <div className="row_item">
                    <span className="label">Gross Wt</span>
                    <span className="value">{item.TotalGrosswt.toFixed(3)}</span>
                  </div>
                  <div className="row_item">
                    <span className="label">Net Wt</span>
                    <span className="value">{item.TotalNetwt.toFixed(3)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesReport;

// import React, { useEffect, useRef, useState } from "react";
// import "./SalesReport.scss";
// import {
//   CircularProgress,
//   InputAdornment,
//   Box,
//   IconButton,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { IoIosSearch, IoMdClose } from "react-icons/io";
// import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
// import Header from "../../Home/Header/Header";
// import CustomTextField from "../../../TextFiled/Index";

// const SalesReport = () => {
//   const [filteredData, setFilteredData] = useState([]);
//   const [saleData, setSaleData] = useState([]);
//   const [pageSize, setPageSize] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);
//   const gridRef = useRef(null);
//   const [searchQuery, setSearchQuery] = useState("");

//   useEffect(() => {
//     const handleResize = () => {
//       if (gridRef.current) {
//         gridRef.current.style.height = `${window.innerHeight - 130}px`;
//       }
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     setIsLoading(true);
//     CommonAPImain("Report_Sale")
//       .then((response) => {
//         if (response?.Data?.DT) {
//           const formattedData = response.Data.DT.map((item, index) => ({
//             ...item,
//             id: index + 1, 
//           }));
//           setFilteredData(formattedData);
//           setSaleData(formattedData);
//           setIsLoading(false);
//         }
//       })
//       .catch((err) => {
//         console.error(err);
//         setIsLoading(false);
//       });
//   }, []);

//   const handleSearch = (e) => {
//     const searchValue = e.target.value.toLowerCase();
//     setSearchQuery(searchValue);

//     const filteredSales = saleData.filter((sale) =>
//       sale.CustomerCode.toLowerCase().includes(searchValue)
//     );
//     setFilteredData(filteredSales);
//   };

//   const columns = [
//     {
//       field: "CustomerCode",
//       headerName: "Customer Code",
//       width: 150,
//     },
//     {
//       field: "TotalBillAndAmount",
//       headerName: "Bill / Amount",
//       width: 140,
//       renderCell: (params) => (
//         <div className="twocolum_mainDiv">
//           <div
//             style={{ display: "flex", height: "20px", alignItems: "center" }}
//           >
//             {params.row.TotalBill}
//           </div>
//           <div
//             style={{ height: "20px", display: "flex", alignItems: "center" }}
//           >
//             {params.row.TotalAmount.toFixed(2)}
//           </div>
//         </div>
//       ),
//     },
//     {
//       field: "TotalWeight",
//       headerName: "GWt / NWt",
//       width: 100,
//       renderCell: (params) => (
//         <div className="twocolum_mainDiv">
//           <div
//             style={{ display: "flex", height: "20px", alignItems: "center" }}
//           >{`GW: ${params.row.TotalGrosswt.toFixed(3)}`}</div>
//           <div
//             style={{ display: "flex", height: "20px", alignItems: "center" }}
//           >{`NW: ${params.row.TotalNetwt.toFixed(3)}`}</div>
//         </div>
//       ),
//     },
//   ];

//   const clearSearch = () => {
//     setSearchQuery("");
//     setFilteredData(saleData);
//   };

//   return (
//     <div className="employee_main">
//       <Header otherPage={true} title="Sale Report" />
//       <div style={{ padding: "65px 5px 5px 5px" }}>
//         <Box mb={2}>
//           <CustomTextField
//             className="searchBox_input"
//             value={searchQuery}
//             onChange={handleSearch}
//             placeholder="Search ..."
//             InputProps={{
//               endAdornment: searchQuery && (
//                 <IconButton onClick={clearSearch}>
//                   <IoMdClose className="catelog_searchClose_icone" />
//                 </IconButton>
//               ),
//             }}
//           />
//         </Box>
//         <div
//           ref={gridRef}
//           style={{
//             width: "100%",
//             backgroundColor: "white",
//           }}
//         >
//           <DataGrid
//             rows={filteredData || []}
//             columns={columns}
//             pageSize={pageSize}
//             onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//             loading={isLoading}
//             localeText={{ noRowsLabel: "No Data" }}
//             initialState={{
//               pagination: {
//                 paginationModel: {
//                   pageSize: 25,
//                 },
//               },
//             }}
//             components={{
//               Toolbar: () => null,
//               LoadingOverlay: () => (
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     height: "100%",
//                   }}
//                 >
//                   Loading...
//                 </div>
//               ),
//             }}
//             rowsPerPageOptions={[5, 10, 15, 25, 50]}
//             pagination
//             className="employee_datagrid"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesReport;
